var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dashboard-layout',[_c('dash-board-a-p-i-keys-and-webhooks-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }